import { Grid } from "@mantine/core";
import { memo } from "react";
import ClientPaymentMethods from "./paymentMethods";
import TransactionHistory from "../../TransactionHistory";

const ClientPayments = () => {
  return (
    <Grid>
      <Grid.Col md={6}>
        <TransactionHistory />
      </Grid.Col>

      <Grid.Col md={6}>
        <ClientPaymentMethods />
      </Grid.Col>
    </Grid>
  );
};

export default memo(ClientPayments);
